import { Button } from "@/components/Button/Button";
import { AppText } from "@/components/Text/AppText";
import { useAppSelector } from "@/hooks/types";
import { useTenantFeature } from "@/hooks/useTenantFeature";
import { ChangeEmail } from "@/pages/Profile/ChangeEmail";
import { ChangeNames } from "@/pages/Profile/ChangeNames";
import { ChangePreferences } from "@/pages/Profile/ChangePreferences";
import { getIs1TemplateTenant } from "@/store/tenant/selectors";
import { getUserDetails } from "@/store/user/selectors";
import { AppRoutes } from "@/types/routes";
import { ITenantFeature } from "@/types/tenant";

export const ProfileDetails = () => {
    const userEmail = useAppSelector(getUserDetails)?.email;
    const isPrefWizardEnabled = useTenantFeature(
        ITenantFeature.PreferencesWizard,
    );
    const is1TemplateTenant = useAppSelector(getIs1TemplateTenant);

    return (
        <div className="flex flex-col">
            <AppText
                variant="headings"
                className="mb-8 hidden text-neutral-900 md:block"
            >
                Profile
            </AppText>
            <div className="mb-8 md:mb-0">
                <AppText
                    variant="subheadings"
                    className="mb-4 text-neutral-900"
                >
                    Basic info
                </AppText>
                <ChangeNames />
            </div>
            <div className="mb-8 md:mb-0">
                <AppText
                    className="mb-4 text-neutral-900 "
                    variant="subheadings"
                >
                    Change Email
                </AppText>
                <AppText
                    className="mb-4 text-neutral-700"
                    variant="labelsbuttons"
                >
                    Before you can update your email, we’ll need to verify your
                    new email address.
                </AppText>
                <AppText
                    className="mb-4 mt-2 block text-neutral-700 md:mt-0"
                    variant="labelsbuttons"
                >
                    Current email: {userEmail}
                </AppText>
                <ChangeEmail />
            </div>
            {is1TemplateTenant && (
                <div className="mb-8 md:mb-0">
                    <ChangePreferences />
                </div>
            )}
            {isPrefWizardEnabled && (
                <div className="mb-8 md:mb-0">
                    <AppText
                        variant="subheadings"
                        className="mb-4 text-neutral-900"
                    >
                        Preferences
                    </AppText>
                    <AppText
                        className="mb-4 block text-neutral-700"
                        variant="labelsbuttons"
                    >
                        Manage and update your account preferences.
                    </AppText>
                    <Button
                        to={`/${AppRoutes.Preferences}?redirect=${AppRoutes.Profile}`}
                        className="float-end mb-4"
                        variant={"solid"}
                        color={"grey"}
                    >
                        Manage preferences
                    </Button>
                </div>
            )}
        </div>
    );
};
